export default __webpack_public_path__ + "static/proposjoner-eksempel1-b2a4f4f72a15f0309434c7084dfe2ba9.png";